import { render, staticRenderFns } from "./reset-pwd.vue?vue&type=template&id=17b4a88f&scoped=true&"
import script from "./reset-pwd.vue?vue&type=script&lang=js&"
export * from "./reset-pwd.vue?vue&type=script&lang=js&"
import style0 from "./reset-pwd.vue?vue&type=style&index=0&id=17b4a88f&lang=less&scoped=true&"
import style1 from "./reset-pwd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b4a88f",
  null
  
)

export default component.exports